import FormattedMessage from 'I18n/components/FormattedMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { H2 } from 'foundations-components/transitional/components/H2';
import ScopesAuthorization from 'developer-experience-shared-components/scopes/v3/components/ScopesAuthorization';
import { AddIcon, SprocketIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Image } from 'foundations-components/transitional/components/Image';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PermissionsModal = ({
  onClose,
  scopeGroups
}) => {
  const {
    iconUrl,
    name
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsxs(Modal, {
    width: 500,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.requirementsCard.permissions.modal.header"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      paddingBlockEnd: "1200",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        paddingBlock: "400",
        children: [/*#__PURE__*/_jsx(Image, {
          alt: name,
          src: iconUrl,
          maxBlockSize: "60px"
        }), /*#__PURE__*/_jsx(View, {
          as: "span",
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(AddIcon, {
            color: "icon-primary-disabled",
            size: "600"
          })
        }), /*#__PURE__*/_jsx(SprocketIcon, {
          color: "fill-brand-default",
          size: "900"
        })]
      }), /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.requirementsCard.permissions.modal.subtitle",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(ScopesAuthorization, {
        scopes: scopeGroups
      })]
    })]
  });
};